import { render, staticRenderFns } from "./GestionFaqs.vue?vue&type=template&id=c9086f2e"
import script from "./GestionFaqs.vue?vue&type=script&lang=js"
export * from "./GestionFaqs.vue?vue&type=script&lang=js"
import style0 from "./GestionFaqs.vue?vue&type=style&index=0&id=c9086f2e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports